import { render, staticRenderFns } from "./PayTypeComponent.vue?vue&type=template&id=307d6962&"
import script from "./PayTypeComponent.vue?vue&type=script&lang=js&"
export * from "./PayTypeComponent.vue?vue&type=script&lang=js&"
import style0 from "./PayTypeComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports